import 'svelte/internal/disclose-version';
import 'svelte/internal/flags/legacy';
import * as $ from 'svelte/internal/client';
import { toolStore } from "@/stores/tools.svelte";

var $$_import_toolStore = $.reactive_import(() => toolStore);
var root = $.from_html(`<div class="color-picker svelte-3k46emzl5ra17"><label class="section-label svelte-3k46emzl5ra17">Color &amp; Opacity</label> <div class="color-row svelte-3k46emzl5ra17"><div class="swatch-wrap svelte-3k46emzl5ra17"><input type="color" class="color-input svelte-3k46emzl5ra17"/></div> <div class="opacity-wrap svelte-3k46emzl5ra17"><input type="range" class="opacity-slider svelte-3k46emzl5ra17" min="0" max="100"/> <span class="opacity-value svelte-3k46emzl5ra17"> </span></div></div></div>`);

function ColorPicker($$anchor, $$props) {
	$.push($$props, false);
	$.init();

	var div = root();
	var div_1 = $.sibling($.child(div), 2);
	var div_2 = $.child(div_1);
	var input = $.child(div_2);

	$.remove_input_defaults(input);
	$.reset(div_2);

	var div_3 = $.sibling(div_2, 2);
	var input_1 = $.child(div_3);

	$.remove_input_defaults(input_1);

	var span = $.sibling(input_1, 2);
	var text = $.child(span);

	$.reset(span);
	$.reset(div_3);
	$.reset(div_1);
	$.reset(div);

	$.template_effect(() => {
		$.set_value(input, $$_import_toolStore().color);
		$.set_value(input_1, $$_import_toolStore().opacity);
		$.set_text(text, `${$$_import_toolStore().opacity ?? ''}%`);
	});

	$.delegated('input', input, (e) => $$_import_toolStore($$_import_toolStore().color = e.currentTarget.value));
	$.delegated('input', input_1, (e) => $$_import_toolStore($$_import_toolStore().opacity = Number(e.currentTarget.value)));
	$.append($$anchor, div);
	$.pop();
}

if (import.meta.hot) {
	ColorPicker = $.hmr(ColorPicker);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-3k46emzl5ra17');
		ColorPicker[$.HMR].update(module.default);
	});
}

export default ColorPicker;

$.delegate(['input']);
import "bun-svelte:ColorPicker.svelte-3upg804lwj3fh-style.css";